import React from "react";
import {
  TransactionInput,
  TransactionInputContainer,
  TransactionInputText,
} from "./styles";

const TransactionInputSection = ({
  value,
  setValue,
  title,
  type,
  maxLength,
}: any) => {
  return (
    <TransactionInputContainer>
      <TransactionInputText style={{ marginLeft: 10, marginTop: 15 }}>
        {title}
      </TransactionInputText>
      <TransactionInput
        placeholder={value === 0 ? "" : value}
        value={value === 0 ? "" : value}
        type={"text"}
        maxLength={maxLength ? maxLength : 100}
        onChange={(e: any) => {
          setValue(e.target.value);
        }}
        style={{
          border: "none",
          paddingLeft: maxLength ? 80 : 80,
          paddingRight: maxLength ? 70 : 70,
        }}
      />
      <TransactionInputText style={{ right: 40, marginTop: 15 }}>
        {type}
      </TransactionInputText>
    </TransactionInputContainer>
  );
};

export default React.memo(TransactionInputSection);
